import { useMemo } from 'react';

import { AVAILABLE_LANGS } from '@common/constants';

const getOptionDetails = (option) => {
  const foundLangOption = AVAILABLE_LANGS.find(
    ({ value }) => value === option.language,
  );
  return { ...foundLangOption, isDefault: option?.isDefault };
};

export default function useMemoLanguageOptions(editor) {
  const availableLangOptions = useMemo(() => {
    const langOptions = editor?.map(({ language, isDefault, label }) => ({
      language,
      isDefault,
      label,
    }));
    return langOptions?.map((option) => getOptionDetails(option)) || [];
  }, [editor]);

  return availableLangOptions;
}
